module.exports = __webpack_public_path__ + "img/ffc_icon.8c72303c.svg";